import {ValueObject} from '@s-ui/domain'

export class PageViewHitTrackingValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {string} data.adId
   * */

  /**
   * Validation method
   */
  static validate({adId, errorFactory}) {
    if (!adId) throw errorFactory('Page View hit needs an ad ID')
  }
}
